type CurrencyCode = 'ARS' | 'USD' | 'EUR' | 'BRL' | 'CLP' | 'MXN' | string;

export const formatPrice = (
  value: number,
  currency: CurrencyCode = 'ARS',
  locale: string = 'es-AR',
  options?: Intl.NumberFormatOptions
): string => {
  if (typeof Intl?.NumberFormat !== 'function') {
    return value.toString();
  }

  const defaultOptions: Intl.NumberFormatOptions = {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  };

  return new Intl.NumberFormat(locale, {
    ...defaultOptions,
    ...options
  }).format(value);
};